import React, { FC } from 'react';
import styles from './modal_scrollable_content.module.scss';

export const ModalScrollableContent: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
